import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Cuánto tiempo tarda en mejorar mi crédito?',
  answer: 'Los resultados varían según cada caso, pero la mayoría de nuestros estudiantes ven mejoras en su puntaje en los primeros 30 a 45 días después de enviar sus primeras cartas de disputa.'
}, {
  question: '¿Funciona si solo tengo número de ITIN?',
  answer: '¡Absolutamente! Tenemos un módulo completo dedicado a cómo construir y reparar crédito utilizando únicamente tu número de ITIN, sin necesidad de Seguro Social.'
}, {
  question: '¿Es legal reparar mi propio crédito?',
  answer: 'Sí, es 100% legal. La Ley de Informes Crediticios Justos (FCRA) te otorga el derecho de disputar cualquier información inexacta, desactualizada o no verificable en tu reporte de crédito.'
}, {
  question: '¿Tendré que pagar mensualidades?',
  answer: 'No. Arquitecto de Crédito USA es un pago único de $19.99. Obtienes acceso de por vida a todo el material y a futuras actualizaciones sin cargos ocultos.'
}, {
  question: '¿Qué pasa si no me funciona?',
  answer: 'Ofrecemos una garantía de satisfacción de 30 días. Si aplicas el sistema y sientes que no es para ti, te devolvemos el 100% de tu dinero sin hacer preguntas.'
}, {
  question: '¿Necesito experiencia previa en finanzas?',
  answer: 'Para nada. El programa está diseñado desde cero, con un lenguaje sencillo y paso a paso, para que cualquier persona pueda entenderlo y aplicarlo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-25">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
        <div className="text-center mb-16" data-id="element-27">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-28">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-slate-600" data-id="element-29">
            Resolvemos tus dudas para que tomes la mejor decisión.
          </p>
        </div>

        <div className="space-y-4" data-id="element-30">
          {faqs.map((faq, index) => <div key={index} className="border border-slate-200 rounded-xl overflow-hidden" data-id="element-31">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center bg-slate-50 hover:bg-slate-100 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-32">
                <span className="font-bold text-navy-900 pr-4" data-id="element-33">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-34" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-35">
                <div className="p-6 bg-white text-slate-600 leading-relaxed border-t border-slate-100" data-id="element-36">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}